/**
 * @author Akash Mishra <akashmishra@eurofins.com>
 */
import { Injectable } from '@angular/core';
import { MatDialog , MatDialogConfig , MatDialogRef  } from '@angular/material/dialog';
import { OrderReportDialogComponent } from 'src/app/feature/results/order-report-dialog/order-report-dialog.component';

import { AnnouceBannerComponent } from '../announcement/annouce-banner/annouce-banner.component';
import { ClindxTableFilterComponent } from '../clindx-table-filter/clindx-table-filter.component';
import { ObsoleteBrowserBannerComponent } from '../obsolete-browser-banner/obsolete-browser-banner.component';
import { PasswordExpiryDialogComponent } from '../password-expiry-dialog/password-expiry-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class DialogService {
  get openConfig(): MatDialogConfig {
    return {
      width: 'fit-content',
      panelClass: 'confirm-dialog-container',
      restoreFocus: false,
      disableClose: false
    } as MatDialogConfig;
  }

  // tslint:disable-next-line: no-shadowed-variable
  set openConfig(matConfig: MatDialogConfig) {
    this.openConfig = matConfig;
  }

  constructor(private dialog: MatDialog, private dialog1: MatDialog) { }

  public exportConfig: MatDialogConfig = {
    width: '250px',
    panelClass: 'export-dialog',
    hasBackdrop: true,
    restoreFocus: false
  };

  public filterConfig: MatDialogConfig = {
    width: '260px',
    panelClass: 'search-filter-dialog',
    position: { left: '15px' },
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
    restoreFocus: false
  };

  filterDialog(Data?: any) {
    const filterConfig = this.filterConfig;
    if (Data) {
      filterConfig.data = Data;
    }
    return this.dialog.open(ClindxTableFilterComponent, filterConfig);
  }

  OpenDialog(componentName: any, configFile?: MatDialogConfig, Data1?: any, Data2?: any) {
    let modelConfig = this.openConfig;
    if (configFile) {
      modelConfig = configFile;
    }
    if (Data1) {
      modelConfig.data = Data1;
    } else if (Data1 && Data2) {
      modelConfig.data = { Data1, Data2 };
    }
    return this.dialog.open(componentName, modelConfig);
  }

  closeAllDialog() {
    if (this.dialog) {
      this.dialog.closeAll();
    }
    if (this.dialog1) {
      this.dialog1.closeAll();
    }
  }

  public openResultTableDialog({
    positionRelativeToElement, rowData, dialogService }:
    {
      positionRelativeToElement: any,
      rowData: any,
      dialogService: DialogService
    }): MatDialogRef<OrderReportDialogComponent> {

    const dialogRef: MatDialogRef<OrderReportDialogComponent> =
      this.dialog.open(OrderReportDialogComponent, {
        hasBackdrop: true,
        maxHeight: '300px',
        width: 'fit-content',
        data: { positionRelativeToElement, data: rowData, dialogService },
        restoreFocus: false,
        panelClass: 'open-result-dialog-container'
      });
    return dialogRef;
  }

  openPasswordExpiryDialog(expiryDate: any) {
    if (!this.dialog.openDialogs || this.dialog.openDialogs.length > 0) { return; }
    return this.dialog.open(PasswordExpiryDialogComponent, {
      width: '767px',
      panelClass: 'password-expiry-dialog',
      hasBackdrop: false,
      data: { expiryDate },
      position: { top: '4%' }
    });
  }

  openAnnouncementDialog(type: string, customData: any) {
    if (!this.dialog.openDialogs || this.dialog.openDialogs.length > 0) {
      return undefined;
    }
    return this.dialog.open(AnnouceBannerComponent, {
      panelClass: 'annoncement-dialog',
      hasBackdrop: type !== 'BANNER',
      disableClose: type !== 'BANNER',
      data: { type, data: customData },
      position: { top: '4%' }
    });
  }

  obsoleteBrowserBanner(bannerData: any) {
    if (!this.dialog1.openDialogs || this.dialog1.openDialogs.length > 0) {
      return;
    }
    return this.dialog1.open(ObsoleteBrowserBannerComponent, {
      hasBackdrop: false,
      position: { bottom: '1%' },
      height: (screen.width <= 599) ? 'auto' : '150px',
      data: bannerData
    });
  }
}
